import * as React from 'react'
import {
  useGetServiceClassifications,
  useSetServiceClassification,
  useGetVendorsServiceClassifications,
  useDeleteServiceClassification
} from 'vendors/queries/useServicesQuery'

type UseServiceClassificationsResponse = {
  serviceListProps: {
    onChange: (id: string, checked: boolean) => void
    selectedServiceClassifications: string[]
    serviceClassifications: ServiceClassificationResponseType[]
  }
  isLoading: boolean
  isError: boolean
}

const useServiceClassifications = (vendorId: string): UseServiceClassificationsResponse => {
  const {
    data: serviceClassifications = [],
    isLoading: isServicesLoading,
    isError: isServicesError
  } = useGetServiceClassifications()

  const { data, isLoading, isError } = useGetVendorsServiceClassifications(vendorId)

  const { mutate: setServiceClassification, isError: isErrorOnSetServiceClassification } =
    useSetServiceClassification(vendorId)

  const { mutate: deleteServiceClassification, isError: isErrorOnDeleteServiceClassification } =
    useDeleteServiceClassification(vendorId)

  const selectedServiceClassifications = React.useMemo(() => {
    if (!data) {
      return []
    }

    return data.map((item) => item.serviceClassificationId)
  }, [data])

  const onChange = (id: string, checked: boolean) => {
    if (checked) {
      setServiceClassification(id)
    } else {
      deleteServiceClassification(id)
    }
  }

  return {
    serviceListProps: {
      onChange,
      selectedServiceClassifications,
      serviceClassifications
    },
    isLoading: isLoading || isServicesLoading,
    isError: isError || isErrorOnSetServiceClassification || isErrorOnDeleteServiceClassification || isServicesError
  }
}

export default useServiceClassifications
